module.exports = __webpack_public_path__ + "static/media/Ad_Hoc_Poster.9a423048.pdf";